var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"markdownContent",attrs:{"v-html":_vm.rendered},on:{"click":function (event) { return _vm.$emit('click', event); }}},[_vm._t("default")],2),_c('div',{ref:"dynamic"})])}
var staticRenderFns = []

export { render, staticRenderFns }